import React, { PureComponent, createRef, Fragment } from 'react';
import './ArametPrediction.css';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';
import L from 'leaflet';
import omnivore from '@mapbox/leaflet-omnivore';
import * as icons from '../../img';
import {
    limitsComarquesAmbMar,
    limitsMunicipis,
    baseTiles,
    suffixUrlTilesAramet,
} from '../../utils/urls';
import {    
    DEFAULT_CONFIG,
    CATALUNYA_CENTER,
    MAX_BOUNDS,
} from '../../utils/globals';
import { 
    debounce, 
    omplirDimensionsTileLayer,
    getColorTemperaturaTopoJson, 
    getColorPrecipitacioTopoJson,
    getColorHumitatTopoJson 
} from '../../utils/utils';

import { translate } from '../../utils/translations';


import ArametDoublePopup from '../ArametPopup/ArametDoublePopup';
//import { createArametNavControl } from '../ArametNav/ArametNavControl';
//import { createArametNavControlCollapsible } from '../ArametNav/ArametNavControlCollapsible';
//import ArametNav from '../ArametNav/ArametNav';
import '../ArametNav/ArametNav.css';
//import ArametTextNav from '../ArametNav/ArametTextNav';

const dayBoxDimensions = { width: 150, height: 176 };
const dayBoxDoubleWidth = 311;
const comarcaLayerPointerOffset = 20;
//const dayBoxOffset = 20;
const DEFAULT_ZOOM = 7;
const FIRST_ID_SEA_LAYER = 88;
const FILL_OPACITY_GEOJSON = 0.5;
const STROKE_OPACITY_GEOJSON = 0;

//ens indica quan comença a canviar el topojson de comarques a municipis o viceversa
const LIMIT_SWAP_COMARQUES_MUNICIPIS = 7;

//ens indica quan comença a canviar el topojson de comarques a municipis o viceversa
const LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS = 9;

//ens indica quan comencem a ensenyar els símbols al mapa de capital comarca o municipis
const LIMIT_SWAP_MARKERS_COMARQUES_MUNICIPIS = 9;

const TOPOJSON_FUNCTIONS = [ getColorTemperaturaTopoJson, getColorPrecipitacioTopoJson, getColorHumitatTopoJson ];
const capes = ['temperatures', 'precipitacions', 'humitat'];

const buscaElementDinsArametData = (data, propData, propietat, valor) => {

    return data[ propData ].find( (m) => { return m[propietat] === valor } )

};



export class ArametPrediction extends PureComponent {
    state = {
        popupName: '',
        isDayBoxActive: false,
        comarcaId: 0,
        comarcaName: '',
        capitalComarca: '',
        comarcaX: 0,
        comarcaY: 0,
        dayBoxConfig: {            
            color: this.props.color || DEFAULT_CONFIG.color,
            language: this.props.language || DEFAULT_CONFIG.language,
        },
        dayBoxData: {
            est_cel: {},
            est_cel_simbol: {},
            name_elements: {},
            current_temp: {},
            prec_acum: {},
            current_vent: {},
            vent_dir: {},
            current_hum: {}
        },
        municipisTopojsonLoad: false, 
    };


    mapContainer = createRef();
    zoom = this.props.zoom || DEFAULT_ZOOM;
                    

    static propTypes = {
        mapId: PropTypes.string,
        dataAramet: PropTypes.object,
        selectedNavItem: PropTypes.number,   
        onNavItemSelect : PropTypes.func,
        language: PropTypes.string,
        topoJsonNav: PropTypes.object,        
        color: PropTypes.string,    
        zoom: PropTypes.number,
    };


    render() {
        const {
            isDayBoxActive,
            comarcaX,
            comarcaY,           
            dayBoxConfig,
            dayBoxVars,
            dayBoxData,
            popupName,
            comarcaId,
        } = this.state;

       
        const { mapId, color } = this.props;

        //afegim akest control pq quan surtim del mapa en el cas de popup doble no desapareix
        const handleMouseLeave = () => {            
            this.setState({ isDayBoxActive: false });
        };

        return (
            <Fragment>
               
                <div
                    id={mapId}
                    className="ArametPrediction mc-leaflet-map"                    
                    ref={this.mapContainer}
                    aria-label={translate(this.props.language, 'aramet_map_title')}
                >                    
                    
                    {/* PINTA POPUP */}
                    {isDayBoxActive &&(    
                                            
                        <div
                            onMouseLeave={handleMouseLeave}
                            className={"mc-aramet-popup mc-widget "+(dayBoxData.current_temp.valor.length >1 ? 'mc-aramet-double-popup' : '')}
                            style={{
                                left: comarcaX,
                                top: comarcaY,
                            }}
                        >
                            <div
                                className="mc-aramet-popup__header"
                                style={{ background: color }}
                            >
                                <p>{popupName}</p>
                            </div>
                            
                                <ArametDoublePopup
                                    config={dayBoxConfig}
                                    variables={dayBoxVars}
                                    data={dayBoxData}
                                    dayName={''}
                                    index={1}
                                    onlyOneDayBox={true}
                                    color={color}
                                    comarcaId={comarcaId}
                                />                            
                           
                        </div>
                    )}
                </div>
            </Fragment>
        );
    }

    componentDidMount() {

        if (document.querySelector(`#${this.props.mapId}`)) {

            this.map = L.map(this.props.mapId, {
                center: [CATALUNYA_CENTER.latitude, CATALUNYA_CENTER.longitude],
                zoomSnap: 1,
                zoom: this.zoom,
                maxZoom: 12,
                minZoom: 7,
                maxBounds: MAX_BOUNDS,
            });


            //Creem panes per poder assignar z-index i no tenir problemes amb l'ordre de layers
            //this.map.createPane('paneForMunicipis');
            //this.map.createPane('paneForComarques');

            
            this.generateTileLayer(`${baseTiles}${suffixUrlTilesAramet}`, {}).addTo(
                this.map
            );
            

            /*
            //ABANS
            //LIMIT_SWAP_COMARQUES_MUNICIPIS = 9;
             this.municipisTopojson = null;

            this.comarquesTopojson = this.topojsonLayerGenerator(this.zoom).addTo(
                this.map
            );

            */

            /*this.municipisTopojson = this.topojsonLayerGenerator(this.zoom).addTo(
                this.map
            );*/
            
            /*
            Creem les dues capes de topojson, tant comarques com municipis.
            comarques sempre serà transparent d'estils i la treurem si el zoom >= 10
            */
            /*this.municipisTopojson = this.topojsonLayerGenerator(this.zoom).addTo(
                this.map
            ).setZIndex(20);

            this.comarquesTopojson = this.topojsonLayerGenerator(6).addTo(
                this.map
            ).setZIndex(10);*/


            /* -------- LAYER CONTROL LEAFLET --------- */
            /*
            this.municipisTopojson = this.topojsonLayerGenerator(this.zoom).addTo(
                this.map
            );            
                        
            this.comarquesTopojson = this.topojsonLayerGenerator(6).addTo(
                this.map
            );
            */
            /* -------- LAYER CONTROL LEAFLET --------- */
         
            

            /* -------- LAYER CONTROL LEAFLET --------- */
            this.municipisTopojson = this.topojsonLayerTypeGenerator(this.zoom, 0);  
            this.comarquesTopojson = this.topojsonLayerTypeGenerator(6, 0);
            this.temperaturesGroupLayer = L.layerGroup([this.municipisTopojson, this.comarquesTopojson]).addTo(this.map);


            this.municipisPrecTopojson = this.topojsonLayerTypeGenerator(this.zoom, 1);  
            this.comarquesPrecTopojson = this.comarquesTopojson;    
            this.precipitacionsGroupLayer = L.layerGroup([this.municipisPrecTopojson, this.comarquesPrecTopojson]);


            this.municipisHumitatTopojson = this.topojsonLayerTypeGenerator(this.zoom, 2);  
            this.comarquesHumitatTopojson = this.comarquesTopojson;
            this.humitatGroupLayer = L.layerGroup([this.municipisHumitatTopojson, this.comarquesHumitatTopojson]);



            var baseMaps = {
                [translate(this.props.language, 'aramet_legend_title_0')]: this.temperaturesGroupLayer,
                [translate(this.props.language, 'aramet_legend_title_1')]: this.precipitacionsGroupLayer,
                [translate(this.props.language, 'aramet_legend_title_2')]: this.humitatGroupLayer
            };

            this.layerControl = L.control.layers(baseMaps).addTo(this.map);

            document.querySelector('.MapaAramet').style.setProperty('--checked-color', this.props.color);
            


            var lang = this.props.language;
            var onChangeSelected = this.props.onNavItemSelect;

            this.map.on('baselayerchange', function(e) {
                
                const tempTranslation = translate(lang, 'aramet_legend_title_0');
                const precTranslation = translate(lang, 'aramet_legend_title_1');
                const humitatTranslation = translate(lang, 'aramet_legend_title_2');

                let selectedNavItem = 0; 
                
                if (e.name === tempTranslation) {
                    selectedNavItem = 0; // temp
                } else if (e.name === precTranslation) {
                    selectedNavItem = 1; // preci
                } else if (e.name === humitatTranslation) {
                    selectedNavItem = 2; // humitat
                }
                

                
                // actualitzem selectedNavItem
                if (onChangeSelected) {
                    onChangeSelected(selectedNavItem);
                }


            });

            /* -------- LAYER CONTROL LEAFLET --------- */



            // Afegim el layer control amb el component ArametNav  
            /**-----AKI--------- arametNavControl */ 
            /*this.arametNavControl = createArametNavControl({
                componentChild: ArametTextNav,
                position: 'topright',
                collapsed: true,
                topoJsonNav: this.props.topoJsonNav || { 0: true, 1: false },
                language: this.props.language || 'ca',
                color: this.props.color || '#2c3e50',
                onNavItemSelect: this.props.onNavItemSelect,
                selectedNavItem: this.props.selectedNavItem || 0
            }).addTo(this.map);*/

            
            /*
            this.arametNavControl = createArametNavControlCollapsible({
                componentChild: ArametTextNav,
                position: 'topright',
                collapsed: true,
                topoJsonNav: this.props.topoJsonNav || { 0: true, 1: false },
                language: this.props.language || 'ca',
                color: this.props.color || '#2c3e50',
                onNavItemSelect: this.props.onNavItemSelect,
                selectedNavItem: this.props.selectedNavItem || 0
            }).addTo(this.map);
            */
            
            
            
            /*this.arametNavControl = createArametNavControl({
                componentChild: ArametNav,
                position: 'topright',
                collapsed: true,
                topoJsonNav: this.props.topoJsonNav || { 0: true, 1: false },
                language: this.props.language || 'ca',
                color: this.props.color || '#2c3e50',
                onNavItemSelect: this.props.onNavItemSelect,
                selectedNavItem: this.props.selectedNavItem || 0
            }).addTo(this.map);*/
            

            
            
                      


            const zoom = this.calculateZoom();
            this.map.setZoom(zoom);
            this.paintIcons(Math.floor(zoom * 10) / 10);
            this.props.setParentZoomState(zoom);
        }


        

        
        window.addEventListener(
            'resize',
            debounce(() => {
                const zoom = this.calculateZoom();
                this.map.setZoom(zoom);
                this.map.removeLayer(this.layer);
                this.paintIcons(Math.floor(zoom * 10) / 10);
            })
        );
        

        this.map.on('zoomend', () => {

            const zoom = Math.floor(this.map.getZoom() * 12 / 12);
            //const previousZoom = this.zoom;
            this.zoom = zoom;

           
            /*
            if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                if (this.comarquesTopojson) {
                    this.map.removeLayer(this.comarquesTopojson);
                }
               
            }else{                
                this.comarquesTopojson.addTo(this.map);
            }     
            */



            /* -------- LAYER CONTROL LEAFLET --------- */

            
            const selectedNavItem = this.props.selectedNavItem || 0;
               

            // Determina quina capa activa segons selectedNavItem            
            if (selectedNavItem === 0) {                
                if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                    if (this.comarquesTopojson) {
                        this.map.removeLayer(this.comarquesTopojson);
                    }                                 
                }else{ 
                     this.comarquesTopojson.addTo(this.map);
                }  
            } else if (selectedNavItem === 1) {
                if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                    if (this.comarquesPrecTopojson) {
                        this.map.removeLayer(this.comarquesPrecTopojson);
                    }                                 
                }else{ 
                     this.comarquesPrecTopojson.addTo(this.map);
                } 
            } else if (selectedNavItem === 2) {
                if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                    if (this.comarquesHumitatTopojson) {
                        this.map.removeLayer(this.comarquesHumitatTopojson);
                    }                                 
                }else{ 
                     this.comarquesHumitatTopojson.addTo(this.map);
                } 
            }  
           /* -------- LAYER CONTROL LEAFLET --------- */
                  
                


            // Si el zoom canvia de <8 a >=8 o viceversa, recarreguem el topojson
            /*if ((previousZoom < LIMIT_SWAP_COMARQUES_MUNICIPIS && zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS) || (previousZoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS && zoom < LIMIT_SWAP_COMARQUES_MUNICIPIS)) {                
                
                //si encara no tenim carregat el topojson de municipis l'anem a buscar
                if(!this.state.municipisTopojsonLoad){
                    
                    //carreguem el topojson dels municipis
                    this.reloadTopojsonLayer();

                    //indiquem que el topojson de municipis ja sha carregat. D'aquesta manera ja no el tornem a recarregar
                    this.setState({municipisTopojsonLoad : true});
                
                }else{
                    
                    //segons el zoom en què estem afegim la capa topojson de municipis o la de comarques
                    if(this.zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS){
                        if (this.comarquesTopojson) {
                            this.map.removeLayer(this.comarquesTopojson);
                        }
                        this.municipisTopojson.addTo(this.map);
                    }else{
                        if (this.municipisTopojson) {
                            this.map.removeLayer(this.municipisTopojson);
                        }
                        this.comarquesTopojson.addTo(this.map);
                    }                    

        


                }
                

                
            }*/
            
            this.map.removeLayer(this.layer);            
            this.paintIcons(zoom);
            this.props.setParentZoomState(zoom);                        
            
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handler);

         // netegem el layer control
        if (this.arametNavControl) {
            this.map.removeControl(this.arametNavControl);
            this.arametNavControl = null;
        }

    }

    componentDidUpdate(prevProps) {

        const { color, selectedNavItem } = this.props;
        
        document.querySelector('.MapaAramet').style.setProperty('--checked-color', color);
            

        /* -------- LAYER CONTROL LEAFLET --------- */
        if (selectedNavItem !== prevProps.selectedNavItem) {
            this.syncLayerWithSelectedNavItem();
        }
        /* -------- LAYER CONTROL LEAFLET --------- */

        
        
        //const component = this;



        /* -------- LAYER CONTROL CUSTOM --------- */
        /*
        this.applyTopojsonStyles(this.municipisTopojson);        
        
        if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
            if (this.comarquesTopojson) {
                this.map.removeLayer(this.comarquesTopojson);
            }
            
        }else{                
            this.comarquesTopojson.addTo(this.map);
        } 
        */
        /* -------- LAYER CONTROL CUSTOM --------- */

        

        
        // Aplicar estils al topojson existent        
        /*if(this.zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS){
            this.applyTopojsonStyles(this.municipisTopojson);
        }else{
            this.applyTopojsonStyles(this.comarquesTopojson);
        }*/
        

        
        // actualitzem el layer control amb el component ArametNav si les props han canviat
        /**-----AKI--------- arametNavControl */         
        /*if (this.arametNavControl && (
            selectedNavItem !== prevProps.selectedNavItem ||
            topoJsonNav !== prevProps.topoJsonNav ||
            language !== prevProps.language ||
            onNavItemSelect !== prevProps.onNavItemSelect ||
            color !== prevProps.color
        )) {
            this.arametNavControl.updateOptions({
                componentChild: ArametNav,
                selectedNavItem,
                topoJsonNav,
                language,
                color,
                onNavItemSelect
            });
        }*/

        /* -------- LAYER CONTROL CUSTOM --------- */
        /*
        if (this.arametNavControl && (
            selectedNavItem !== prevProps.selectedNavItem ||
            topoJsonNav !== prevProps.topoJsonNav ||
            language !== prevProps.language ||
            onNavItemSelect !== prevProps.onNavItemSelect ||
            color !== prevProps.color
        )) {
            this.arametNavControl.updateOptions({
                componentChild: ArametTextNav,
                selectedNavItem,
                topoJsonNav,
                language,
                color,
                onNavItemSelect
            });
        }*/
        /* -------- LAYER CONTROL CUSTOM --------- */

        
        
    }


    syncLayerWithSelectedNavItem() {

        if (!this.layerControl) return;
        
        const selectedNavItem = this.props.selectedNavItem || 0;

        
        //this.precipitacionsGroupLayer,
        //this.humitatGroupLayer
        
        // Determina quina capa activem segons selectedNavItem
        let targetLayer = null;
        if (selectedNavItem === 0) {
            // Temperatures            
            if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                targetLayer = [this.municipisTopojson];                
            }else{ 
                targetLayer = [this.municipisTopojson, this.comarquesTopojson];     
            }  

        } else if (selectedNavItem === 1) {
            // Precipitacions            
            if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                targetLayer = [this.municipisPrecTopojson];                
            }else{ 
                targetLayer = [this.municipisPrecTopojson, this.comarquesPrecTopojson];     
            }  
        } else if (selectedNavItem === 2) {
            // humitat
            if(this.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                targetLayer = [this.municipisHumitatTopojson];                
            }else{ 
                targetLayer = [this.municipisHumitatTopojson, this.comarquesHumitatTopojson];     
            }  
           
        }
        
        if (targetLayer) {

            // eliminem capes
            this.map.removeLayer(this.municipisTopojson);
            this.map.removeLayer(this.comarquesTopojson);
            this.map.removeLayer(this.municipisPrecTopojson);
            this.map.removeLayer(this.comarquesPrecTopojson);
            this.map.removeLayer(this.municipisHumitatTopojson);
            this.map.removeLayer(this.comarquesHumitatTopojson);            

            //afegim les que toca
            targetLayer.forEach((element) => element.addTo(this.map));
            
        }

        
    }


    /*addControlLayer(){

        this.control = L.control({position: 'topright'});

        const currentColor = this.props.color;
        const currentLanguage = this.props.language;
        const currentSelected = this.props.selectedNavItem;

        const handleNavItemSelected = this.props.onNavItemSelect;

        this.control.onAdd = function(){            

            const div = L.DomUtil.create('div', 'leaflet-control-layers-expanded custom-control');

            div.id = 'meteocat-custom-control';
             
            render(                
                <ArametNavControl
                    color={currentColor}               
                    topoJsonNav={{
                        0: true,
                        1: false,            
                    }}                
                    language={currentLanguage}             
                    onNavItemSelect = {handleNavItemSelected}
                    selectedNavItem={currentSelected}
                ></ArametNavControl>                
                ,div);           

            return div;
        }
        this.control.addTo(this.map);
    }*/

    generateTileLayer(tilesUrl, layerOptions) {
        var newTile = L.tileLayer(tilesUrl, layerOptions);

        /*newTile.getTileUrl = function(tilePoint) {
            return L.Util.template(
                this._url,
                {
                    z: ('0' + tilePoint.z).slice(-2),
                    x: ('00' + tilePoint.x).slice(-3),
                    // For some reason Y axis is inverted, so we have to reorder tiles
                    y: (
                        '00' +
                        (this._globalTileRange.max.y - tilePoint.y)
                    ).slice(-3),
                },
                this.options
            );
        };*/
         

        newTile.getTileUrl = function(tilePoint) {            

            var optionsAux = {
                    z: ('0' + tilePoint.z).slice(-2),
                    x: ('00' + tilePoint.x).slice(-3),
                    // For some reason Y axis is inverted, so we have to reorder tiles
                    y: (
                        '00' +
                        (this._globalTileRange.max.y - tilePoint.y)
                    ).slice(-3),
                    dimX: omplirDimensionsTileLayer(tilePoint.x).dim,
                    dimY: omplirDimensionsTileLayer(this._globalTileRange.max.y - tilePoint.y).dim
                };
            

            return L.Util.template(
                this._url,
                optionsAux,
                this.options
            );
        };

        return newTile;
    }

    

    topojsonLayerGenerator(zoom = this.zoom) {

        

        const layerStyles = L.geoJson(null, {
            style: () => {
                return {
                    opacity: 0,
                    fillOpacity: 0,
                    width: 0,
                    color: 'transparent',
                };
            },
            /*pane: (zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS) ?  'paneForMunicipis' : 'paneForComarques',*/
            pane: (zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS) ?  'overlayPane' : 'shadowPane',
        });

        // can't use arrow functions with omnivore ...
        const component = this;

        // Seleccionar quin topojson segons el zoom
        const topojsonFile = zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS ? limitsMunicipis : limitsComarquesAmbMar;

        //const topojsonFile = limitsComarquesAmbMar;
                

        return omnivore
            .topojson(topojsonFile, null, layerStyles)
            .on('ready', function() {
                this.eachLayer(layer => {

                    layer.on('mouseover', layer => {

                        const {
                            IDComarca,
                            NOM_COMAR: nomComarca,
                            CAPCOMAR: capitalComarca,
                        } = layer.sourceTarget.feature.properties;
                        const { x, y } = layer.containerPoint;

                        const mapDimensions = {
                            w: document.getElementById(component.props.mapId)
                                .offsetWidth,
                            h: document.getElementById(component.props.mapId)
                                .offsetHeight,
                        };

                        


                        let comarcaX = x + comarcaLayerPointerOffset;
                        let comarcaY = y + comarcaLayerPointerOffset;
                        let amplePopup = dayBoxDimensions.width;
                        

                        /*
                        mirem si el popup és doble. En cas afirmatiu marquem que l'amplada serà de dayBoxDoubleWidth
                        ho necessitem per controlar que el popup no sortirà de pantalla
                        */
                        if(layer.sourceTarget.feature.properties.IDComarca){
                            if(layer.sourceTarget.feature.properties.CAPCOMAR !== null){
                                const myArray = layer.sourceTarget.feature.properties.CAPCOMAR.split("/"); 
                                if(myArray.length >=2 ){   
                                    amplePopup = dayBoxDoubleWidth;
                                }
                            }
                            

                        }
                        
                        
                        // controlem que el popup si queda per fora de la pantalla el resitui dins
                        if (
                            x +
                                amplePopup +
                                comarcaLayerPointerOffset >
                            mapDimensions.w
                        ) {

                            let popupPosicioAmple = (x + amplePopup + comarcaLayerPointerOffset);
                            let hemDeMoure = (mapDimensions.w-popupPosicioAmple);
                            
                            comarcaX = x + hemDeMoure;

                            /*
                            console.log('surto dels límits X');
                            console.log('posicio popup:::'+(x+comarcaLayerPointerOffset))
                            console.log(mapDimensions.w+'----'+popupPosicioAmple);                            
                            console.log('hem de desplaçar::'+hemDeMoure)                                                        
                            console.log(x + hemDeMoure)
                            */
                            
                            //comarcaX = x - dayBoxOffset;
                        }
                        if (
                            y +
                                dayBoxDimensions.height +
                                comarcaLayerPointerOffset >
                            mapDimensions.h
                        ) {

                            let popupPosicioAltura = y + dayBoxDimensions.height + comarcaLayerPointerOffset;
                            let hemDeMoureY = (mapDimensions.h-popupPosicioAltura);
                            comarcaY = y + hemDeMoureY;
                           
                            //comarcaY = y - dayBoxOffset;
                        }

                       
                         
                        //Mirem si tenim la propietat comarca
                        if(layer.sourceTarget.feature.properties.IDComarca){
                            

                            if(component.props.zoom <= LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                                
                                //mirem si es tracta de mar o no
                                if (component.isNotSeaLayer(IDComarca)) {
                                    
                                    //excepció per Vielha
                                    if( layer.sourceTarget.feature.properties.CAPCOMAR === "Vielha"){
                                        
                                        component.setState({
                                            comarcaId: IDComarca,
                                            popupName: nomComarca,
                                            comarcaName: nomComarca,
                                            capitalComarca : 'Vielha e Mijaran',
                                            comarcaX: comarcaX,
                                            comarcaY: comarcaY,
                                        });
                                        
                                    }else{
                                        
                                        component.setState({
                                            comarcaId: IDComarca,
                                            popupName: nomComarca,
                                            comarcaName: nomComarca,
                                            capitalComarca : capitalComarca,
                                            comarcaX: comarcaX,
                                            comarcaY: comarcaY,
                                        });
                                        
                                    };
                                     
                                    component.setDayBoxData();
                                }
                            }
                            
                        }else{
                            
                            if(component.props.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                                //sabem que és municipi
                                component.setState({
                                        comarcaId: IDComarca,
                                        popupName: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        comarcaName: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        capitalComarca: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        comarcaX: comarcaX,
                                        comarcaY: comarcaY,
                                    });

                                component.setDayBoxData();
                            }
                            
                        }

                        

                        
                    });

                    var temperatura = null;

                    
                    if(layer.feature.properties.IDComarca){

                        layer.setStyle({
                                opacity: 0,
                                fillOpacity: 0,
                                color: 'transparent',
                                fillColor: 'transparent',                            
                        });
                        
                        /*layer.setStyle({
                                opacity: 0,
                                fillOpacity: FILL_OPACITY_GEOJSON,
                                color: 'blue',
                                fillColor: 'blue',                            
                        });*/

                        //si som comarca no pintem estils
                        /*if (component.isNotSeaLayer(layer.feature.properties.IDComarca)) {

                        

                            
                            const arametInfo = component.props.dataAramet;

                            //console.log(arametInfo)
                            //const tipusVariable = capes[component.props.selectedNavItem];
                            //console.log(tipusVariable)
                            //console.log(arametInfo[ capes[component.props.selectedNavItem] ])

                            var currentCapitalComarca = layer.feature.properties.CAPCOMAR;

                            if(currentCapitalComarca === "Vielha") currentCapitalComarca = 'Vielha e Mijaran';
                            if(currentCapitalComarca === 'Sabadell/Terrassa') currentCapitalComarca="Sabadell";


                            temperatura = arametInfo[ capes[component.props.selectedNavItem] ].find( (m) => { return m.nom === currentCapitalComarca } )

                            //console.log(temperatura);


                            if(temperatura == null){
                                layer.setStyle({
                                    opacity: 0,
                                    fillOpacity: FILL_OPACITY_GEOJSON,
                                    color: 'transparent',
                                    fillColor: 'transparent',
                                
                                });
                            }else{

                                const colorTemp = TOPOJSON_FUNCTIONS[component.props.selectedNavItem](temperatura.valors[0].valor);

                                //console.log('color a pintar');
                                //console.log(colorTemp);

                                layer.setStyle({
                                    opacity: 0,
                                    fillOpacity: FILL_OPACITY_GEOJSON,
                                    color: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,
                                    fillColor: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,
                                });                                

                            }

                        }else{

                            layer.setStyle({
                                opacity: 0,
                                fillOpacity: FILL_OPACITY_GEOJSON,
                                color: 'transparent',
                                fillColor: 'transparent',                            
                            });

                        }*/
                    }else{
                        
                        const arametInfo = component.props.dataAramet;

                            //console.log(arametInfo)
                            //const tipusVariable = capes[component.props.selectedNavItem];
                            //console.log(tipusVariable)
                            //console.log(arametInfo[ capes[component.props.selectedNavItem] ])

                            temperatura = arametInfo[ capes[component.props.selectedNavItem] ].find( (m) => { return m.codi === layer.feature.properties.cm_ine_mun } )

                            //console.log(temperatura);


                            if(temperatura == null){
                                

                                layer.setStyle({
                                    opacity: STROKE_OPACITY_GEOJSON,
                                    fillOpacity: FILL_OPACITY_GEOJSON,
                                    color: 'transparent',
                                    fillColor: 'transparent',
                                
                                });
                            }else{

                                const colorTemp = TOPOJSON_FUNCTIONS[component.props.selectedNavItem](temperatura.valors[0].valor);

                                

                                layer.setStyle({
                                    stroke: true,
                                    weight: 1,
                                    opacity: STROKE_OPACITY_GEOJSON,
                                    fillOpacity: FILL_OPACITY_GEOJSON,
                                    color: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,                                    
                                    fillColor: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,
                                    
                                });                                

                            }
                        
                    }
                                        

                    layer.on('mouseout', () => {
                       
                        component.setState({ isDayBoxActive: false });
                    });
                });
            });
    }


    topojsonLayerTypeGenerator(zoom = this.zoom, tipus) {

        

        const layerStyles = L.geoJson(null, {
            style: () => {
                return {
                    opacity: 0,
                    fillOpacity: 0,
                    width: 0,
                    color: 'transparent',
                };
            },
            smoothFactor: 0.1,
            pane: (zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS) ?  'overlayPane' : 'shadowPane',
        });

        // can't use arrow functions with omnivore ...
        const component = this;

        // Seleccionar quin topojson segons el zoom
        const topojsonFile = zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS ? limitsMunicipis : limitsComarquesAmbMar;

        //const topojsonFile = limitsComarquesAmbMar;
                

        return omnivore
            .topojson(topojsonFile, null, layerStyles)
            .on('ready', function() {
                this.eachLayer(layer => {

                    layer.on('mouseover', layer => {

                        const {
                            IDComarca,
                            NOM_COMAR: nomComarca,
                            CAPCOMAR: capitalComarca,
                        } = layer.sourceTarget.feature.properties;
                        const { x, y } = layer.containerPoint;

                        const mapDimensions = {
                            w: document.getElementById(component.props.mapId)
                                .offsetWidth,
                            h: document.getElementById(component.props.mapId)
                                .offsetHeight,
                        };

                        


                        let comarcaX = x + comarcaLayerPointerOffset;
                        let comarcaY = y + comarcaLayerPointerOffset;
                        let amplePopup = dayBoxDimensions.width;
                        

                        /*
                        mirem si el popup és doble. En cas afirmatiu marquem que l'amplada serà de dayBoxDoubleWidth
                        ho necessitem per controlar que el popup no sortirà de pantalla
                        */
                        if(layer.sourceTarget.feature.properties.IDComarca){
                            if(layer.sourceTarget.feature.properties.CAPCOMAR !== null){
                                const myArray = layer.sourceTarget.feature.properties.CAPCOMAR.split("/"); 
                                if(myArray.length >=2 ){   
                                    amplePopup = dayBoxDoubleWidth;
                                }
                            }
                            

                        }
                        
                        
                        // controlem que el popup si queda per fora de la pantalla el resitui dins
                        if (
                            x +
                                amplePopup +
                                comarcaLayerPointerOffset >
                            mapDimensions.w
                        ) {

                            let popupPosicioAmple = (x + amplePopup + comarcaLayerPointerOffset);
                            let hemDeMoure = (mapDimensions.w-popupPosicioAmple);
                            
                            comarcaX = x + hemDeMoure;

                            /*
                            console.log('surto dels límits X');
                            console.log('posicio popup:::'+(x+comarcaLayerPointerOffset))
                            console.log(mapDimensions.w+'----'+popupPosicioAmple);                            
                            console.log('hem de desplaçar::'+hemDeMoure)                                                        
                            console.log(x + hemDeMoure)
                            */
                            
                            //comarcaX = x - dayBoxOffset;
                        }
                        if (
                            y +
                                dayBoxDimensions.height +
                                comarcaLayerPointerOffset >
                            mapDimensions.h
                        ) {

                            let popupPosicioAltura = y + dayBoxDimensions.height + comarcaLayerPointerOffset;
                            let hemDeMoureY = (mapDimensions.h-popupPosicioAltura);
                            comarcaY = y + hemDeMoureY;
                           
                            //comarcaY = y - dayBoxOffset;
                        }

                       
                         
                        //Mirem si tenim la propietat comarca
                        if(layer.sourceTarget.feature.properties.IDComarca){
                            

                            if(component.props.zoom <= LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                                
                                //mirem si es tracta de mar o no
                                if (component.isNotSeaLayer(IDComarca)) {
                                    
                                    //excepció per Vielha
                                    if( layer.sourceTarget.feature.properties.CAPCOMAR === "Vielha"){
                                        
                                        component.setState({
                                            comarcaId: IDComarca,
                                            popupName: nomComarca,
                                            comarcaName: nomComarca,
                                            capitalComarca : 'Vielha e Mijaran',
                                            comarcaX: comarcaX,
                                            comarcaY: comarcaY,
                                        });
                                        
                                    }else{
                                        
                                        component.setState({
                                            comarcaId: IDComarca,
                                            popupName: nomComarca,
                                            comarcaName: nomComarca,
                                            capitalComarca : capitalComarca,
                                            comarcaX: comarcaX,
                                            comarcaY: comarcaY,
                                        });
                                        
                                    };
                                     
                                    component.setDayBoxData();
                                }
                            }
                            
                        }else{
                            
                            if(component.props.zoom > LIMIT_SWAP_POPUP_COMARQUES_MUNICIPIS){
                                //sabem que és municipi
                                component.setState({
                                        comarcaId: IDComarca,
                                        popupName: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        comarcaName: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        capitalComarca: layer.sourceTarget.feature.properties.cm_nom_mun,
                                        comarcaX: comarcaX,
                                        comarcaY: comarcaY,
                                    });

                                component.setDayBoxData();
                            }
                            
                        }

                        

                        
                    });

                    var temperatura = null;

                    
                    if(layer.feature.properties.IDComarca){

                        layer.setStyle({
                                opacity: 0,
                                fillOpacity: 0,
                                color: 'transparent',
                                fillColor: 'transparent',                            
                        });                        
                        
                    }else{
                        
                        const arametInfo = component.props.dataAramet;
                            

                            temperatura = arametInfo[ capes[tipus] ].find( (m) => { return m.codi === layer.feature.properties.cm_ine_mun } )



                            if(temperatura == null){
                                

                                layer.setStyle({
                                    opacity: STROKE_OPACITY_GEOJSON,
                                    fillOpacity: FILL_OPACITY_GEOJSON,
                                    color: 'transparent',
                                    fillColor: 'transparent',
                                
                                });
                            }else{

                                const colorTemp = TOPOJSON_FUNCTIONS[tipus](temperatura.valors[0].valor);

                                if(colorTemp === null){
                                    layer.setStyle({
                                        stroke: true,
                                        weight: 1,
                                        opacity: 0,
                                        fillOpacity: 0,
                                        color: `rgb(255, 255, 255)`,                                    
                                        fillColor: `rgb(255,255,255)`,
                                        
                                    });   
                                }else{


                    
                   

                                    layer.setStyle({
                                        stroke: true,
                                        weight: 1,
                                        opacity: ( (colorTemp.colorRGB[0] === 255)&&(colorTemp.colorRGB[1] === 255)&&(colorTemp.colorRGB[2] === 255) ) ? 0 : STROKE_OPACITY_GEOJSON,
                                        fillOpacity: ( (colorTemp.colorRGB[0] === 255)&&(colorTemp.colorRGB[1] === 255)&&(colorTemp.colorRGB[2] === 255) ) ? 0 : FILL_OPACITY_GEOJSON,
                                        color: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,                                    
                                        fillColor: `rgb(${colorTemp.colorRGB[0]},${colorTemp.colorRGB[1]},${colorTemp.colorRGB[2]})`,
                                        
                                    });   
                                }

                                                             

                            }
                        
                    }
                                        

                    layer.on('mouseout', () => {

                        //controlem que si estem sobre del popup no es tanqui pq si no fa efecte flick (sobretot quan tenim popup doble)
                        var element = document.querySelector('.mc-aramet-popup');
                        if ((element !== null)&&(element.matches(':hover'))) {
                           
                        }else{
                            component.setState({ isDayBoxActive: false });
                        }


                        
                    });
                });
            });
    }

    paintIcons(zoom) {
        let markers = []; // just a container for all icons

        const { dataAramet } = this.props;

        //console.log(dataAramet)

        markers = markers.concat(
            this.produceIconsMeu(markers, dataAramet.capitals, dataAramet.municipis_symbol, 'est_cel_', zoom),            
        );

        /*
        for(var k=1; k<markers.length; k++){
            console.log(markers[k])
            if((typeof markers[k] !== 'undefined')&&(typeof markers[k-1] !== 'undefined')){
                console.log('distancia entre '+markers[k-1].options.nom+'--'+markers[k].options.nom)
                console.log(this.map.distance(markers[k-1].getLatLng(), markers[k].getLatLng()));

                
            } else {
                console.log('som undefined'+k+'***'+(k-1))
            }
            //console.log('+++++++++'+markers[k].getLatLng());
        }
        

        const nousMarkers = markers.sort((a, b) => this.map.distance(a.getLatLng(), b.getLatLng()) );
        console.log(markers);
        console.log(nousMarkers)
        */


        this.layer = L.layerGroup(markers).addTo(this.map);

        //per no fer-los focusable (accessibilitat)
        /*markers.forEach(marker => {
            marker._icon.tabIndex = -1;
        });*/
    }


    produceIconsMeu(markers, dataCapitals, dataSimbols, iconPrefix, zoom) {
        let iconsSize;
        const zoomCases = [6, 6.5, 7, 8, 9, 10, 11, 12];
        const iconSizes = [18, 24, 24, 32, 32, 32, 56, 56];

        switch (true) {
            case zoom < zoomCases[1]:                
                iconsSize = iconSizes[0];
                break;
            case zoom < zoomCases[2]:
                iconsSize = iconSizes[1];
                break;
            case zoom < zoomCases[3]:
                iconsSize = iconSizes[2];
                break;
            case zoom < zoomCases[4]:
                iconsSize = iconSizes[3];
                break;
            case zoom < zoomCases[5]:
                iconsSize = iconSizes[4];
                break;
            case zoom < zoomCases[6]:
                iconsSize = iconSizes[5];
                break;
            case zoom < zoomCases[7]:
                iconsSize = iconSizes[6];
                break;

            case zoom >= zoomCases[7]:
                iconsSize = iconSizes[7];
                break;
            default:
                iconsSize = iconSizes[1];
        }



        if(zoom <= LIMIT_SWAP_MARKERS_COMARQUES_MUNICIPIS){
            dataCapitals.forEach(item => {

                const simbolMunicipi = dataSimbols.find( (m) => { return m.nom === item.descripcio } )

                let icon = null;
                let estatCelAccessibilitat = '';
                if(simbolMunicipi){
                    icon = icons[`${iconPrefix}${simbolMunicipi.valors[0].valor || 0}`];

                    estatCelAccessibilitat = translate(this.props.language, 'estat_cel_'+simbolMunicipi.valors[0].valor);
                }                

                if (icon) {
                    markers.push(
                        L.marker(
                            [simbolMunicipi.coordenada.latitud, simbolMunicipi.coordenada.longitud],
                            {
                                icon: new L.DivIcon({
                                    html: `<img class="marker-estat-cel" src="${icon}" width="${iconsSize}" height="${iconsSize}" alt="${item.descripcio+' '+estatCelAccessibilitat}" />`,
                                    iconAnchor: [iconsSize / 2, iconsSize / 2],
                                }), 
                                interactive: false                                                          
                            }
                        )
                    );
                }

            })
        }else{

            dataSimbols.forEach(item => {            

                const icon = icons[`${iconPrefix}${item.valors[0].valor || 0}`];
                
                if (icon) {
                    markers.push(
                        L.marker(
                            [item.coordenada.latitud, item.coordenada.longitud],
                            {
                                icon: new L.DivIcon({
                                    html: `<img class="marker-estat-cel" src="${icon}" width="${iconsSize}" height="${iconsSize}" alt="${item.descripcion+' '+translate(this.props.language, 'estat_cel_'+item.valors[0].valor)}" />`,
                                    iconAnchor: [iconsSize / 2, iconsSize / 2],
                                }),
                                interactive: false
                                
                            }
                        )
                    );
                }
            });

        }        

        
        return markers;
    }

    produceIcons(markers, data, iconPrefix, zoom) {
        let iconsSize;
        const zoomCases = [6, 6.5, 7, 8, 9];
        const iconSizes = [18, 24, 32, 48, 70];

        switch (true) {
            case zoom < zoomCases[1]:
                iconsSize = iconSizes[0];
                break;
            case zoom < zoomCases[2]:
                iconsSize = iconSizes[1];
                break;
            case zoom < zoomCases[3]:
                iconsSize = iconSizes[2];
                break;
            case zoom < zoomCases[4]:
                iconsSize = iconSizes[3];
                break;
            case zoom >= zoomCases[4]:
                iconsSize = iconSizes[4];
                break;
            default:
                iconsSize = iconSizes[1];
        }


        
        data.forEach(item => {
            
            const icon = icons[`${iconPrefix}${item.codi || item.velocitat}`];

            
            if (icon) {
                markers.push(
                    L.marker(
                        [item.coordenades.latitud, item.coordenades.longitud],
                        {
                            icon: new L.DivIcon({
                                html: `<img src="${icon}" width="${iconsSize}" height="${iconsSize}" style="${
                                    item.direccio
                                        ? `transform: rotate(${
                                              item.direccio
                                          }deg); -ms-transform: rotate(${
                                              item.direccio
                                          }deg); -webkit-transform: rotate(${
                                              item.direccio
                                          }deg);`
                                        : ''
                                } " /> ${
                                    item.beaufort
                                        ? `<span>${item.beaufort}</span>`
                                        : ''
                                }`,
                                iconAnchor: [iconsSize / 2, iconsSize / 2],
                            }),
                        }
                    )
                );
            }
        });
        return markers;
    }

    // Feed state with current comarca data in order to render dayBox
    setDayBoxData = () => {
                
        const { capitalComarca } = this.state;
        
        //mirem si tenim el símbol / pq això vol dir que hi ha més d'un valor (Sabadell/Terrassa)
        const myArray = capitalComarca.split("/")
        .map(v => v.trim()) // neteja espais a l'inici i final
        .filter(Boolean); // evita buits        
        this.setMultipleDayBoxData(myArray);

    };


    //passem l'array amb els múltiples municipis que necessitem la informació
    setMultipleDayBoxData = (values) => {
        const {            
            dataAramet            
        } = this.props;
        
        let name_elements = {
            valor: []
        };
        let est_cel = {
            valor: []
        };
        let est_cel_simbol = {
            valor: []
        };
        let current_temp = {
            valor: []
        };
        let prec_acum = {
            valor: []
        };
        let current_vent = {
            valor: []
        };
        let vent_dir = {
            valor: []
        };
        let current_hum = {
            valor: []
        };

       

        for(var i=0; i< values.length; i++){           

            let capitalComarca = values[i];
            

            name_elements.valor[i] = capitalComarca;

            //var infoSimbol = dataAramet[ 'municipis_symbol' ].find( (m) => { return m.nom === capitalComarca } )
            var infoSimbol = buscaElementDinsArametData(dataAramet, 'municipis_symbol', 'nom', capitalComarca);  


            let icona = 's/d';

            if (typeof(infoSimbol) !== 'undefined' && infoSimbol !== null) {
                est_cel_simbol.valor[i] = infoSimbol.valors[0].valor; 
                
                //const iconaUrl = dataAramet[ 'cataleg' ].find( (s) => { return s.codi === infoSimbol.valors[0].valor.toString()});
                const iconaUrl = buscaElementDinsArametData(dataAramet, 'cataleg', 'codi', infoSimbol.valors[0].valor.toString());
                icona = iconaUrl ? iconaUrl.icona : 's/d';                
            }else{
                est_cel_simbol.valor[i] = 's/d';
            }
            
            //var temperatura = dataAramet[ 'temperatures' ].find( (m) => { return m.nom === capitalComarca } );
            const temperatura = buscaElementDinsArametData(dataAramet, 'temperatures', 'nom', capitalComarca);

            let temp = 's/d';

            //no tenim temperatura
            if (typeof(temperatura) !== 'undefined' && temperatura != null) {
                temp = temperatura.valors[0].valor;
            }

            const infoPrecipitacio = dataAramet['precipitacions'].find( (m) => { return m.nom === capitalComarca } );

            let prec = 's/d';
            if (typeof(infoPrecipitacio) !== 'undefined' && infoPrecipitacio != null) {
                prec = infoPrecipitacio.valors[0].valor;
            }


            const infoVentSpeed= dataAramet['wind_speed'].find( (m) => { return m.nom === capitalComarca } );

            let vent = 's/d';            
            if (typeof(infoVentSpeed) !== 'undefined' && infoVentSpeed != null) {
                vent = (infoVentSpeed.valors[0].valor*3.6).toFixed(0);
            }

            const infoVentDir= dataAramet['wind_dir'].find( (m) => { return m.nom === capitalComarca } );

            let ventDir = 's/d';
            if (typeof(infoVentDir) !== 'undefined' && infoVentDir != null) {            
                ventDir = Math.round(infoVentDir.valors[0].valor);
            }

            const humitat = buscaElementDinsArametData(dataAramet, 'humitat', 'nom', capitalComarca);

            let hum = 's/d';
            //no tenim humitat
            if (typeof(humitat) !== 'undefined' && humitat != null) {
                hum = humitat.valors[0].valor;
            }

            current_hum.valor[i] = hum;

            est_cel.valor[i] = icona;

            current_temp.valor[i] = temp;                
            
            prec_acum.valor[i] = prec;

            current_vent.valor[i] = vent;

            vent_dir.valor[i] = ventDir;


        }
        
                        
        const dayBoxData = {
            est_cel,
            est_cel_simbol,
            current_temp,
            prec_acum,
            current_vent,
            vent_dir,
            name_elements,
            current_hum
        };
        
        
        this.setState({ dayBoxData, isDayBoxActive: true });


    };

    calculateZoom = () => {
        let zoom = DEFAULT_ZOOM;
        let w = window.innerWidth;
        let h = window.innerHeight;

        if (document.querySelector('.one-map') && this.mapContainer.current) {
            const headerHeight = 150;
            // * 2 because it only applies to one map widget
            w = this.mapContainer.current.offsetWidth * 1.8;
            h = this.mapContainer.current.offsetHeight * 2 + headerHeight;
        }

        if (this.props.preview) return zoom;
        if (w > 1300 && h > 730) return 8;
        if (w > 700 && h > 450) return 7;
        if (w > 271 && h > 230) return 6;
        if (w < 272) return 6;

        return zoom;
    };

    isNotSeaLayer = IDComarca => IDComarca < FIRST_ID_SEA_LAYER;

    reloadTopojsonLayer = () => {

        
        if((this.zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS)&&(!this.state.municipisTopojsonLoad)){

           
            // eliminem el topojson actual
            if (this.comarquesTopojson) {
                this.map.removeLayer(this.comarquesTopojson);
            }

            //topojson municipis  
            //this.municipisTopojson = this.topojsonLayerGenerator(this.zoom).addTo(this.map);
            this.applyTopojsonStyles(this.municipisTopojson);
        }else{

            /*
            PER AKI NO HAURIA DE PASSAR MAI
            */
            
            //topojson comarques
            /*if (this.comarquesTopojson) {
                this.map.removeLayer(this.comarquesTopojson);
            }


            // crea i afegeix el nou topojson amb el zoom actual
            //this.comarquesTopojson = this.topojsonLayerGenerator(this.zoom).addTo(this.map);
            this.applyTopojsonStyles(this.comarquesTopojson);
            */
        }

              
        //this.applyTopojsonStyles();


    };

    applyTopojsonStyles = (elementTopojson) => {

        const component = this;
        
        if (!elementTopojson) return;
                

        elementTopojson.eachLayer(function(layer){
            component.municipisTopojsonStyles(component, layer);     
        })

        /*elementTopojson.eachLayer(function(layer){
                        
           // Determina si és municipi o comarca en funció del zoom
            const isMunicipi = component.zoom >= LIMIT_SWAP_COMARQUES_MUNICIPIS;

            if(isMunicipi){
                //console.log('********************PIntem topo estils municipis');
                component.municipisTopojsonStyles(component, layer);
            }else{
                //console.log('********************PIntem topo estils comarques');
                component.comarquesTopojsonStyles(component, layer);
            }

        })
        */
        
    };

    comarquesTopojsonStyles = (component, layer) => {


        if (component.isNotSeaLayer(layer.feature.properties.IDComarca)) {

            const arametInfo = component.props.dataAramet;
            
            var currentCapitalComarca = layer.feature.properties.CAPCOMAR;
            
            if(currentCapitalComarca === "Vielha") currentCapitalComarca = 'Vielha e Mijaran';
            if(currentCapitalComarca === 'Sabadell/Terrassa') currentCapitalComarca="Sabadell";

            var infoPintar = arametInfo[ capes[component.props.selectedNavItem] ].find( (m) => { return m.nom === currentCapitalComarca } )

            if(infoPintar === undefined){

                layer.setStyle({
                    opacity: 0,
                    fillOpacity: FILL_OPACITY_GEOJSON,
                    color: 'transparent',
                    fillColor: 'transparent',
                
                });
            }else{

                const colorPintar = TOPOJSON_FUNCTIONS[component.props.selectedNavItem](infoPintar.valors[0].valor);

                if(colorPintar !== undefined){

                    layer.setStyle({
                        stroke: true,
                        weight: 1,
                        opacity: STROKE_OPACITY_GEOJSON,
                        fillOpacity: FILL_OPACITY_GEOJSON,
                        color: `rgb(${colorPintar.colorRGB[0]},${colorPintar.colorRGB[1]},${colorPintar.colorRGB[2]})`,
                        fillColor: `rgb(${colorPintar.colorRGB[0]},${colorPintar.colorRGB[1]},${colorPintar.colorRGB[2]})`,
                    });
                }

            }
            

        }else{

            layer.setStyle({
            opacity: 0,
            fillOpacity: FILL_OPACITY_GEOJSON,
            color: 'transparent',
            fillColor: 'transparent',
            
            });

        }

    };

    municipisTopojsonStyles= (component, layer) => {
        
        const currentMunicipi = layer.feature.properties.cm_nom_mun;

        if(currentMunicipi === null){

            layer.setStyle({
                opacity: 0,
                fillOpacity: FILL_OPACITY_GEOJSON,
                color: 'transparent',
                fillColor: 'transparent',            
            });

        }else{

            const arametInfo = component.props.dataAramet;
            
            var infoPintar = arametInfo[ capes[component.props.selectedNavItem] ].find( (m) => { return m.codi === layer.feature.properties.cm_ine_mun } )
            
            if((typeof(infoPintar) === 'undefined')||(infoPintar === null)){                

                layer.setStyle({
                    opacity: STROKE_OPACITY_GEOJSON,
                    fillOpacity: FILL_OPACITY_GEOJSON,
                    color: 'transparent',
                    fillColor: 'transparent',               
                });

            }else{

                const colorPintar = TOPOJSON_FUNCTIONS[component.props.selectedNavItem](infoPintar.valors[0].valor);

                let opacityGeometry = FILL_OPACITY_GEOJSON;
                let strokeOpacity = STROKE_OPACITY_GEOJSON;

                if(colorPintar !== null){

                    if( (colorPintar.colorRGB[0] === 255)&&(colorPintar.colorRGB[1] === 255)&&(colorPintar.colorRGB[2] === 255) ){
                        opacityGeometry = 0;
                        strokeOpacity = 0;
                    }
                
                    layer.setStyle({
                        stroke: true,
                        weight: 1,
                        opacity: strokeOpacity,
                        fillOpacity: opacityGeometry,
                        color: `rgb(${colorPintar.colorRGB[0]},${colorPintar.colorRGB[1]},${colorPintar.colorRGB[2]})`,
                        fillColor: `rgb(${colorPintar.colorRGB[0]},${colorPintar.colorRGB[1]},${colorPintar.colorRGB[2]})`,
                    });

                }else{

                    layer.setStyle({
                        stroke: true,
                        weight: 1,
                        opacity: 0,
                        fillOpacity: 0,
                        color: `rgb(255,255,255)`,
                        fillColor: `rgb(255,255,255)`,
                    });

                }

                

            }

        }

    };

}



// WEBPACK FOOTER //
// ./src/partials/ArametPrediction/ArametPrediction.js